import { FormGroupState } from 'ngrx-forms';
import { first, takeUntil } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseContainer } from '@ideapa/app-base-components';

import { AuthFacade } from '../../+state/auth.facade';
import { ResetPasswordFormValue } from '../../+state/auth.reducer';

@Component({
  standalone: false,
  templateUrl: './reset-password.container.html',
  styleUrls: ['./reset-password.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordContainer extends BaseContainer implements OnInit {
  queryParams$ = this.authFacade.seletQueryParams$;
  resetForm$ = this.authFacade.selectResetPasswordForm$;
  authError$ = this.authFacade.selectAuthError$;

  // private username?: string;
  private token?: string;

  get showResetButton() {
    return !!this.token;
  }

  constructor(private authFacade: AuthFacade) {
    super();
  }

  onSubmit(form: FormGroupState<ResetPasswordFormValue>) {
    if (this.token && form.isValid) {
      this.authFacade.resetPassword(this.token, form.value.newPassword);
    }
  }

  ngOnInit() {
    this.queryParams$
      .pipe(first(), takeUntil(this.ngUnsubscribe))
      .subscribe((params) => {
        this.token = params['reset_token'];
      });
  }

  resetAuthError() {
    this.authFacade.resetAuthError();
  }
}
